export default {
  translation: {
    nav: {
      home: 'ホーム',
      trips: '旅行',
      aboutUs: '会社概要',
      alerts: 'お知らせ',
      wishlist: 'お気に入り',
      language: '言語',
      profile: 'プロフィール',
      settings: '設定',
      signIn: 'ログイン',
      signUp: '新規登録'
    },
    hero: {
      title: 'ウガンダを探検',
      subtitle: 'そしてその先へ',
      description: '地元のエキスパートガイドと共にアフリカの真珠を発見しましょう。ウガンダの息をのむような景観と活気ある文化で、忘れられない体験があなたを待っています。',
      searchPlaceholder: 'どちらへお出かけですか？',
      categories: {
        all: 'すべて',
        wildlife: '野生動物',
        safari: 'サファリ',
        cultural: '文化',
        adventure: 'アドベンチャー',
        birding: 'バードウォッチング'
      }
    },
    common: {
      from: '～から',
      reviews: 'レビュー',
      viewMore: 'もっと見る',
      book: '予約する',
      seeAll: 'すべて見る',
      loading: '読み込み中...'
    }
  }
};